import React, { useEffect } from "react";
import {
  Flex,
  Grid,
  SimpleGrid,
  Text,
  Spinner,
  Box,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";

import MiniStatistics from "../Dashboard/components/MiniStatistics";
import PartnerPerformanceChart from "./components/PartnerPerformanceChart";
import TopPerformingPartnersChart from "./components/TopPerformingPartnersChart";
import PaidCommissionsChart from "./components/PaidCommissionsChart";
import ReferralLocationChart from "./components/ReferralLocationChart";
import {
  Users,
  UserPlus,
  DollarSign,
  Wallet,
  Trophy,
} from "lucide-react";

import {
  getDriverPartnerAnalyticsSummary,
  getPartnerPerformance,
  getCommissionLiability,
  getPaidCommissions,
  getSuspiciousReferrals,
  getReferredDriverLocations,
  getTopPerformingPartners,
} from "../../../state/actions/driverPartnerAnalyticsActions";
import AnalyticsTable from "./components/AnalyticsTable";

export default function DriverPartnerAnalytics() {
  const dispatch = useDispatch();

  const {
    loading,
    error,
    summary,
    partnerPerformance,
    commissionLiability,
    paidCommissions,
    suspiciousReferrals,
    referredDriverLocations,
    topPerformingPartners,
  } = useSelector(
    (state) => state.driverPartnerAnalytics
  );

  useEffect(() => {
    dispatch(getDriverPartnerAnalyticsSummary());
    dispatch(getPartnerPerformance());
    dispatch(getCommissionLiability());
    dispatch(getPaidCommissions());
    dispatch(getSuspiciousReferrals());
    dispatch(getReferredDriverLocations());
    dispatch(getTopPerformingPartners());
  }, [dispatch]);

  return (
    <Flex
      flexDirection="column"
      pt={{ base: "120px", md: "75px" }}
    >

      <Box  mb={4}>
        
        <Text
          fontSize="sm"
          color="gray.500"
        >
          Monitor partner performance,
          commissions and
          recruitment trends.
        </Text>
      </Box>

      {loading && (
        <Flex
          align="center"
          gap={2}
          mb={4}
        >
         
        </Flex>
      )}

      {error && (
        <Text
          color="red.500"
          mb={4}
        >
          {error}
        </Text>
      )}

      <SimpleGrid
        columns={{
          sm: 1,
          md: 2,
          xl: 5,
        }}
        spacing="24px"
      >
         <MiniStatistics
  title="Partners"
  amount={summary?.total_partners ?? 0}
  percentage={0}
  icon={<Users size={22} />}
  isLoading={loading}
/>

<MiniStatistics
  title="Recruits"
  amount={summary?.total_referred_drivers ?? 0}
  percentage={0}
  icon={<UserPlus size={22} />}
  isLoading={loading}
/>

<MiniStatistics
  title="Commissions"
  amount={`P${summary?.total_commissions ?? 0}`}
  percentage={0}
  icon={<DollarSign size={22} />}
  isLoading={loading}
/>

<MiniStatistics
  title="Paid Out"
  amount={`P${summary?.total_paid_out ?? 0}`}
  percentage={0}
  icon={<Wallet size={22} />}
  isLoading={loading}
/>

<MiniStatistics
  title="Milestones Achieved"
  amount={summary?.total_referral_milestones ?? 0}
  percentage={0}
  icon={<Trophy size={22} />}
  isLoading={loading}
/>
      </SimpleGrid>

      {/* Charts */}
<Grid
  templateColumns={{
    sm: "1fr",
    md: "1fr 1fr",
  }}
  gap="24px"
  mt={6}
>
  <PartnerPerformanceChart
    data={partnerPerformance}
    loading={loading}
  />

  <TopPerformingPartnersChart
    data={topPerformingPartners}
    loading={loading}
  />
</Grid>



<Grid
  templateColumns={{
    sm: "1fr",
    md: "1fr 1fr",
  }}
  gap="24px"
  mt={6}
>
  <PaidCommissionsChart
    data={paidCommissions}
    loading={loading}
  />

  <ReferralLocationChart
    data={referredDriverLocations}
    loading={loading}
  />
</Grid>

{/* <Grid mt={6}>
 <AnalyticsTable
    title="Partner Performance"
    amount={partnerPerformance.length}
    captions={[
        "Rank",
        "Partner",
        "Code",
        "Recruits",
        "Milestones",
        "Commission",
    ]}
    data={partnerPerformance}
    isLoading={loading}
    variant="partnerPerformance"
/>
</Grid> */}

<Grid mt={6}>
  <AnalyticsTable
    title="Top Performing Partners"
    amount={topPerformingPartners.length}
    captions={[
        "Rank",
        "Partner",
        "Code",
        "Recruits",
        "Commission",
    ]}
    data={topPerformingPartners}
    isLoading={loading}
    variant="topPartners"
/>
</Grid>
{/* 
<Grid mt={6}>
 <AnalyticsTable
    title="Paid Commissions"
    amount={paidCommissions.length}
    captions={[
        "Partner",
        "Driver",
        "Amount",
        "Payment Date",
        "Status",
    ]}
    data={paidCommissions}
    isLoading={loading}
    variant="paidCommissions"
/>
</Grid> */}

<Grid mt={6}>
 <AnalyticsTable
    title="Suspicious Recruits"
    amount={suspiciousReferrals.length}
    captions={[
        "Partner",
        "Recruit",
        "Reason",
        "Date",
        "Status",
    ]}
    data={suspiciousReferrals}
    isLoading={loading}
    variant="suspicious"
/>
</Grid>
    </Flex>
  );
}